import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["preview"];

  updateColor(e) {
    this.previewTarget.style.background = `#${e.target.value}`;
  }
}
